import React from 'react';

import { citations, substances, tgitems } from '@Constants';

import AvailableRelativeContextButton from './AvailableRelativeContextButton';


export default function ReactionsRelativeContextsList (props) {
  const {
    availableRelativeContext,
  } = props;

  const citationsItem = availableRelativeContext.get(citations);
  const substancesItem = availableRelativeContext.get(substances);
  const tgitemsItem = availableRelativeContext.get(tgitems);

  return (
    <>
      {
        citationsItem && (
          <>
            <span className="hide-below-laptop">out of&nbsp;</span>
            <AvailableRelativeContextButton {...props} item={citationsItem}/>
          </>
        )
      }
      {
        substancesItem && (
          <>
            ,
            <span className="hide-below-laptop">
              &nbsp;containing
            </span>
            &nbsp;
            <AvailableRelativeContextButton {...props} item={substancesItem}/>
          </>
        )
      }
      {
        tgitemsItem && (
          <>
            ,&nbsp;
            <AvailableRelativeContextButton {...props} item={tgitemsItem}/>
          </>
        )
      }
    </>
  );
}
